import React from "react";
import ColorDot from "../../components/Data/ColorDot";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

interface Props {
    items: {
        color: string;
        name: string;
    }[];
    className?: string;
}

const useStyles = makeStyles({
    overview: {
        display: "flex",
        flexDirection: "row",
        gap: "1rem",
        marginTop: "1rem",
        justifyContent: "flex-end",
        fontWeight: "bold"
    },
    overviewCategory: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
    }
});

const ColorDotLegend: React.FC<Props> = props => {
    const classes = useStyles();

    const { items, className } = props;

    return (
        <div className={clsx(classes.overview, className)}>
            {items.map(item => (
                <span key={item.color} className={classes.overviewCategory}>
                    <ColorDot color={item.color} size={16} />
                    {item.name}
                </span>
            ))}
        </div>
    );
};

export default ColorDotLegend;
